import React from "react";
import "../csscomponent/Stamp.css";

export default function Stamp() {
  return (

<svg width="200" height="200" viewBox="0 0 350 350">

<defs>

<path id="topArc"
 d="M 60 175
    A 115 115 0 0 1 290 175" />

<path id="bottomArc"
 d="M 290 175
    A 115 115 0 0 1 60 175" />

</defs>

{/* top curved text */}
<text className="arc">
  <textPath href="#topArc" startOffset="50%" textAnchor="middle">
    * SERVICES AND DEVELOPER 
  </textPath>
</text>

{/* center */}
<text x="175" y="200" textAnchor="middle" className="coin-text">
  S &amp; D
</text>

{/* bottom curved text */}
<text className="arc">
  <textPath href="#bottomArc" startOffset="50%" textAnchor="middle">
    * SERVICES AND DEVELOPER 
  </textPath>
</text>

</svg>

  );
}
